import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {PlayerService} from '../../../../core/services';
import {TokenService} from '../../../../core/auth';
import {ActivatedRoute} from '@angular/router';
import {Player, Project} from '../../../../core/models';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {Accusation} from '../../../../core/models/accusation';

@Component({
  selector: 'app-project-accusation-details-page',
  templateUrl: './project-accusation-details.page.html'
})
export class ProjectPlayerAccusationDetailsPage implements OnInit {
  projectId: string;
  playerId: string;
  accusationId: string;

  project: Project;
  player: Player;
  accusation: Accusation;
  authUser = this.token.whoAmI();
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private token: TokenService,
    private playerService: PlayerService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService,
  ) {
  }

  ngOnInit() {
    this.loading = true;
    this.route.parent.params.subscribe((params) => {
      this.projectId = params.id;
    });
    this.route.parent.data.subscribe((data) => {
      if (data.project) {
        this.project = Object.assign({}, data.project);
        this.fetchParams();
        this.projectSidebarService.setProject(this.project);
      }
      this.loading = false;
    });
  }

  fetchParams() {
    this.route.params.subscribe((data) => {
      this.playerId = data.playerId;
      this.accusationId = data.accusationId;
      this.loadAccusation(this.projectId);
    });
  }

  loadAccusation(projectId) {
    this.loading = true;
    const query = {projectId: this.project.id};
    this.playerService.getOnePlayerAccusation(this.accusationId, this.playerId, query).subscribe(
      (data) => {
        this.accusation = data;
        this.player = data.player;

        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name, routerLink: ['/project', this.project.id]},
          {label: 'player'},
          {label: this.accusation.player.platformClientId, routerLink: ['/project', this.projectId, 'player', this.playerId]},
          {label: 'accusation'},
          {label: this.accusation.id}
        ]);
      }
    );
  }

}
